import React, { useCallback, useRef, useEffect, useState } from "react";
import {
  Avatar,
  Box,
  Button,
  getColor,
  InfiniteScrollBox,
  InputField,
  Modal,
  Tooltip,
  Typography,
} from "fds";
import "./index.scss";
import { DocInfo, RevisionMap, SignMap } from "../../types/files";
import utilsDocs from "../../shared/utils/docs";
import useDocumentStore from "../../redux/dispatcher/useDocumentStore";
import utilsCommon from "../../shared/utils/common";
import { t } from "i18next";
interface LeaveCommentModalProps {
  open: boolean;
  onClose: () => void;
  isTypeModal?: boolean; // 모달 의견 남기기일 경우 true
  docInfo?: DocInfo;
  simpleDocInfo?: { syncId: string; revisionNo?: number; contentName: string };
  height?: string | number;
}
const LeaveCommentModal: React.FC<LeaveCommentModalProps> = ({
  open,
  onClose,
  isTypeModal = true,
  simpleDocInfo,
  docInfo,
  height,
}) => {
  /** Hook 정리 */
  const { documentState, addContentMemo, getContentMemo } = useDocumentStore();
  const commentListNewCard = useRef([] as any[]);

  /** State 정리 */
  const [comment, changeComment] = useState(""); // 새 의견
  const [key, setKey] = useState(0); // state용
  const [commentDocInfo, changeCommentDocInfo] = useState({
    syncId: "",
    revisionNo: 0,
    contentName: "",
  });
  /** useEffect 정리 */
  useEffect(() => {
    if (!docInfo?.syncId && !simpleDocInfo?.syncId) return;
    changeCommentDocInfo({
      syncId: (simpleDocInfo?.syncId ?? docInfo?.syncId)!,
      revisionNo: (simpleDocInfo?.revisionNo ?? docInfo?.revisionNo)!,
      contentName: (simpleDocInfo?.contentName ?? docInfo?.contentName)!,
    });
    getContentMemo({ syncId: (simpleDocInfo?.syncId ?? docInfo?.syncId)! });
  }, [docInfo, simpleDocInfo]);
  useEffect(() => {
    let newDataCardContent = [] as any[];
    documentState?.memos?.revisions?.revision.forEach(
      (item: RevisionMap, index: number) => {
        item?.signs?.sign?.map((item1) =>
          newDataCardContent.push(getTableCardData(item1, index))
        );
      }
    );
    commentListNewCard.current = newDataCardContent;
    setKey(key + 1);
  }, [documentState?.memos]);

  /** UI: 의견 테이브틀 리스트 */
  const getTableCardData = (item1: SignMap, index: any) => {
    return {
      id: item1?.signDate,
      data: (
        <Box classes="commentModal-comment">
          <Box alignItems="center">
            <Avatar
              uniqueCode={utilsCommon.getUserColor(item1.userType)}
              name={item1.userName}
              size={"32"}
            />
            <Tooltip message={item1.userName} maxWidth={"calc(100% - 200px)"}>
              <Typography classes="mg ml-4" type="subtitle2" ellipsis>
                {item1.userName}
              </Typography>
            </Tooltip>
            <Typography
              classes="mg ml-4"
              type="body4_rg"
              exactColor={getColor("COLOR_TEXT_SECONDARY")}
            >
              {utilsCommon.renderDateFormat(item1.signDate)}
            </Typography>
          </Box>
          <Box classes="commentModal-comment--msg">
            <Typography type="body2_rg"> {item1.memo}</Typography>
          </Box>
        </Box>
      ),
    };
  };
  /** 의견 남기기 */
  const handleLeaveComment = () => {
    const syncId = commentDocInfo?.syncId ?? "";
    const revisionNo = commentDocInfo?.revisionNo ?? 0;
    addContentMemo({
      memo: comment,
      pushSign: true,
      revisionNo: revisionNo,
      syncId: syncId,
    });
    changeComment("");
  };
  /** UI: 의견 남기기 바디. 모달 위에 띄울땐 body안에 넣고 아니면 전체화면 */
  const renderLeaveCommentModal = () => {
    return (
      <Box
        direction="column"
        width={"calc(100% + 4px)"}
        height={height ?? "100%"}
      >
        <Box width={"calc(100% -4px)"} classes="mg mt-4">
          <InputField
            placeholder={t("file.commentPlaceholder")}
            size="md"
            width={"calc(100% - 97px)"}
            maxLength={512}
            value={comment}
            onChange={(e) => changeComment(e.target.value)}
            onKeyUp={(e) =>
              e.code === "Enter" && comment.length !== 0 && handleLeaveComment()
            }
            disabled={docInfo?.myPolicy?.uniqueId === "ONLYVIEW"}
          />
          <Button
            btnStyle="fill"
            label={t("common.post")}
            classes="mg ml-8"
            size="lg"
            state={comment.length === 0 ? "disable" : "default"}
            width={89}
            onClick={handleLeaveComment}
          />
        </Box>
        <InfiniteScrollBox
          height="100%"
          id="commentModal-comments"
          classes="commentModal-comments"
          data={commentListNewCard.current}
          endReached={() =>
            commentDocInfo?.syncId &&
            documentState?.memos.nextcursor > -1 &&
            getContentMemo({
              syncId: commentDocInfo?.syncId,
              cursor: documentState?.memos?.nextcursor,
              revisionNo: documentState?.memos?.nextRevisionNo,
            })
          }
        />
      </Box>
    );
  };
  return isTypeModal ? (
    <Modal
      open={open}
      onClose={onClose}
      title={t("file.action.comment")}
      width={600}
      bodyHeight={614}
      isFooter={false}
      subTitle={
        <Box alignItems="center">
          {utilsDocs.renderDocIcon(commentDocInfo?.contentName, 24)}
          <Tooltip message={commentDocInfo?.contentName ?? ""}>
            <Typography
              classes="mg ml-8"
              type="body2_rg"
              ellipsis
              maxWidth={485}
            >
              {commentDocInfo?.contentName ?? ""}
            </Typography>
          </Tooltip>
        </Box>
      }
      body={renderLeaveCommentModal()}
    />
  ) : (
    renderLeaveCommentModal()
  );
};
export default LeaveCommentModal;
